
import { Vue, Component } from "vue-property-decorator"
import { CircularLoader } from "@coredination/components"

@Component({
    components: {
        CircularLoader
    }
})
export default class SettingsView extends Vue {
    loading: boolean = false

    goUserSettings() {
        var url: string = process!.env!.VUE_APP_FRONTEND_URL || "http://localhost:8888"
        url += "/#users/me/edit"
        if (localStorage && localStorage.getItem("apollo-token"))
            url += "?api_token=" + localStorage.getItem("apollo-token")
        window.open(url, "_blank")
    }

    clearCache() {
        var cache = this.$apollo?.provider?.defaultClient?.cache
        if (cache && typeof cache.reset == "function"){
            cache.reset()
            var msg: string = this.$t("settings_clearCache_success") as string
            this.$toast.success(msg, { timeout: 2000 })
        }

    }

    refreshCaches() {
        // i'm not actually 100% sure that this refreshes all active queries.
        // i can only get it to refresh the me-query. not sure how to solve it
        // it any other way, this is generally how it's seems to be done in
        // apollo-client 2.x. apollo-client 3.x has client.refetchQueries(),
        // which seems to be a bit more configurable. oh well, i'll leave this
        // for now, and we can improve on it later! // eliaz
        var client: any = this.$apollo!.getClient()
        if (!client) return
        this.loading = true
        client.queryManager.queryDeduplication = false
        client.reFetchObservableQueries().then((response: any) => {
            this.loading = false
            client.queryManager.queryDeduplication = true
            console.log(`Refetched ${response.length} observable query(ies)`)
        })
    }
}
